import type { News } from '@/types';

import BoxImage from '../BoxImage';

import { Box, Button, Link, SectionHeading, SimpleGrid } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const BlogMobile: React.FC<{ blogs: News[] }> = ({ blogs }) => {
  const { t } = useTranslation('pages.home');

  return (
    <>
      <Box textAlign="center" mt="40px">
        <SectionHeading title={t('news')} subtitle={t('chooseNews')} />
        <Button
          variant="outline"
          colorScheme="gray"
          as={Link}
          href={routes.blogs.url}
          mt="20px"
        >
          {t('viewAllBlogs')}
        </Button>
      </Box>
      <SimpleGrid gap="10px" columns={{ base: 1, md: 2, lg: 3 }} mt="50px">
        {blogs.map((blog) => {
          return (
            <BoxImage
              title={blog.title}
              image={blog.preview_image}
              alt={blog.alt_image}
              code={blog.code}
              key={blog.id}
            />
          );
        })}
      </SimpleGrid>
    </>
  );
};
export default BlogMobile;
